import { AuthenticatedHttpService } from 'http/httpService'
import { GlobalSearchError, SearchRequest, SearchResponse } from './schema'

export class GlobalSearchService {
    constructor(private httpService: AuthenticatedHttpService, private backofficeEndpoint: string) {}

    async search(accountSlug: string, request: SearchRequest, signal?: AbortSignal): Promise<SearchResponse> {
        const response = await this.httpService.fetch(
            `${this.backofficeEndpoint}api/v1/accounts/${accountSlug}/search/`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request),
                signal,
            },
        )
        if (response.status === 400) {
            const body = await response.json().catch(() => null)
            throw new GlobalSearchError(
                'Some search filters could not be applied',
                'validation_error',
                body?.filterErrors ?? body?.filter_errors,
            )
        }
        if (response.status === 403) {
            throw new GlobalSearchError('You do not have access to search in this account', 'no_access')
        }
        if (response.status === 404) {
            throw new GlobalSearchError('Account not found', 'account_not_found')
        }
        if (!response.ok) {
            throw new GlobalSearchError(`Global search failed: ${response.status}`, 'unknown')
        }
        const body = await response.json()
        return {
            groups: body.groups ?? {},
            filterErrors: body.filterErrors ?? body.filter_errors,
        }
    }
}
